/**
 * @description Allows to conditionally render the experimental features in the UI.
 */
export const showExperimentalFeatures = Boolean(
  process.env.REACT_APP_SHOW_EXPERIMENTAL_FEATURES &&
    String(process.env.REACT_APP_SHOW_EXPERIMENTAL_FEATURES).toLowerCase() !== 'false',
);
